import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-gray-900 text-white font-sans" data-id="element-2577">
      {/* Header */}
      <header className="bg-black border-b border-gray-800 py-4 px-4" data-id="element-2578">
        <div className="max-w-4xl mx-auto flex items-center gap-4" data-id="element-2579">
          <Link to="/meta-martes" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors" data-id="element-2580">
            <ArrowLeft className="w-5 h-5" data-id="element-2581" />
            <span className="text-sm" data-id="element-2582">Volver</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-2583">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-2584">
          Política de Privacidad
        </h1>

        <div className="text-gray-300 text-sm md:text-base space-y-6 leading-relaxed" data-id="element-2585">
          <p data-id="element-2586">
            En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
            privacidad. Esta política describe cómo recopilamos, usamos y
            protegemos tu información personal.
          </p>

          <section data-id="element-2587">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-2588">
              1. Información que Recopilamos
            </h2>
            <p className="mb-4" data-id="element-2589">
              Recopilamos información que nos proporcionas directamente,
              incluyendo:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2590">
              <li data-id="element-2591">Nombre y dirección de correo electrónico</li>
              <li data-id="element-2592">Número de teléfono móvil</li>
              <li data-id="element-2593">Información de registro del evento</li>
              <li data-id="element-2594">Comunicaciones que mantienes con nosotros</li>
            </ul>
          </section>

          <section data-id="element-2595">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-2596">
              2. Uso de la Información
            </h2>
            <p className="mb-4" data-id="element-2597">Utilizamos tu información para:</p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2598">
              <li data-id="element-2599">
                Proporcionar acceso al masterclass y materiales relacionados
              </li>
              <li data-id="element-2600">Enviar comunicaciones sobre el evento</li>
              <li data-id="element-2601">
                Enviar mensajes SMS/texto con actualizaciones y recordatorios
              </li>
              <li data-id="element-2602">Mejorar nuestros servicios y contenido</li>
              <li data-id="element-2603">Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section data-id="element-2604">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-2605">
              3. Compartir Información
            </h2>
            <p className="mb-4" data-id="element-2606">
              No se compartirá información móvil con terceros ni afiliados con
              fines de marketing ni promocionales. Los datos de suscripción y el
              consentimiento para el uso de mensajes de texto no se compartirán
              con terceros.
            </p>
            <p data-id="element-2607">
              No vendemos ni compartimos tu información personal con terceros
              para fines de marketing. Podemos compartir información con
              proveedores de servicios que nos ayudan a operar nuestro negocio.
            </p>
          </section>

          <section data-id="element-2608">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-2609">
              4. Mensajes SMS/Texto
            </h2>
            <p className="mb-4" data-id="element-2610">
              Al proporcionar tu número de teléfono móvil y dar tu
              consentimiento, aceptas recibir mensajes SMS/texto recurrentes de
              True Marketer LLC, incluyendo:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2611">
              <li data-id="element-2612">Actualizaciones del programa</li>
              <li data-id="element-2613">Información de capacitación</li>
              <li data-id="element-2614">Mensajes de marketing/promocionales</li>
              <li data-id="element-2615">Recordatorios de eventos</li>
            </ul>
            <p className="mt-4" data-id="element-2616">
              La frecuencia de los mensajes varía. Pueden aplicar tarifas de
              mensajes y datos según tu plan de telefonía móvil.
            </p>
            <p className="mt-4" data-id="element-2617">
              <strong className="text-white" data-id="element-2618">Para cancelar:</strong> Responde
              STOP a cualquier mensaje para dejar de recibir mensajes SMS.
            </p>
            <p className="mt-2" data-id="element-2619">
              <strong className="text-white" data-id="element-2620">Para ayuda:</strong> Responde HELP
              para obtener asistencia.
            </p>
            <p className="mt-4" data-id="element-2621">
              El consentimiento para recibir mensajes SMS no es una condición de
              compra.
            </p>
          </section>

          <section data-id="element-2622">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-2623">
              5. Seguridad de Datos
            </h2>
            <p data-id="element-2624">
              Implementamos medidas de seguridad técnicas y organizativas
              apropiadas para proteger tu información personal contra acceso no
              autorizado, alteración o destrucción.
            </p>
          </section>

          <section data-id="element-2625">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-2626">
              6. Tus Derechos
            </h2>
            <p data-id="element-2627">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal. Para ejercer estos derechos, contáctanos en:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] underline" data-id="element-2628">
                support@truemarketer.com
              </a>
            </p>
          </section>

          <section data-id="element-2629">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-2630">
              7. Cookies
            </h2>
            <p data-id="element-2631">
              Utilizamos cookies y tecnologías similares para mejorar tu
              experiencia en nuestro sitio web y analizar el uso del sitio.
            </p>
          </section>

          <section data-id="element-2632">
            <h2 className="text-xl font-bold text-white mt-8 mb-4" data-id="element-2633">Contacto</h2>
            <p data-id="element-2634">
              Para preguntas sobre esta política de privacidad, contacta:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] underline" data-id="element-2635">
                support@truemarketer.com
              </a>
            </p>
          </section>

          <section className="mt-12 pt-8 border-t border-gray-700" data-id="element-2636">
            <p className="text-gray-500 text-sm" data-id="element-2637">
              Última actualización: Febrero 2025
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-gray-800 py-6 px-4" data-id="element-2638">
        <div className="max-w-4xl mx-auto text-center" data-id="element-2639">
          <p className="text-gray-600 text-xs mb-2" data-id="element-2640">
            &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
          </p>
          <p className="text-gray-500 text-xs" data-id="element-2641">
            Soporte:{' '}
            <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-2642">
              support@truemarketer.com
            </a>
          </p>
          <div className="flex items-center justify-center gap-4 text-xs mt-2" data-id="element-2643">
            <Link to="/terms" className="text-gray-500 hover:text-white transition-colors underline" data-id="element-2644">
              Términos
            </Link>
            <span className="text-gray-600" data-id="element-2645">|</span>
            <span className="text-white" data-id="element-2646">Privacidad</span>
          </div>
        </div>
      </footer>
    </div>;
}